import { ReportType } from './../_models/reports/report-type.model';
import { Component, OnDestroy, OnInit, Optional, ViewChild } from '@angular/core'
import { FormGroup, FormBuilder } from '@angular/forms';
import { ReportService, AuthenticationService, ClientService } from '../_services';
import { SuccessModalHelperService } from '../_helpers/success-modal-helper/success-modal-helper.service';
import { ReportsViewComponent } from './reports-view/reports-view.component';
import { ReportDataService } from './report-data.service';
import { ReportClient } from '../_models/reports/report-client.model';
import { FeatureHelperService } from '../_helpers/feature-helper/feature-helper.service';
import { forkJoin, Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { ErrorModalHelperService } from '../_helpers/error-modal-helper/error-modal-helper.service';
import { AuthenticationStateHelperService } from '../_helpers/authentication-state-helper/authentication-state-helper.service';
import { MatSort } from '@angular/material/sort';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FeatureSwitchService } from '../_services/feature-switch/feature-switch.service';
import { FeatureSwitchKeys } from '../_constants/feature-switch-keys';
import { ReportsSentComponent } from './reports-sent/reports-sent.component';
import { FilterState } from '../shared/filter-ux/filter-state';

@Component({
    selector: 'reports-home',
    templateUrl: 'reports-home.component.html',
    styleUrls: ['reports-home.component.css'],
    standalone: false
})

export class ReportsHomeComponent implements OnInit, OnDestroy {
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(ReportsViewComponent, { static: false }) reportView;

  @ViewChild('history', { static: false }) history: ReportsSentComponent;

  public enableGenerateReports: boolean = false;
  /**
   * reports.combined-page: one Reports page (Download and Send to clients on one filter bar, with what was already
   * sent) and a History tab (the sent list). Off, the View, Sent and Generate tabs as before.
   */
  public combinedEnabled: boolean = false;
  public selectedTab = 0;
  private unsubscribe = new Subject<void>();


  constructor(
    private authenticationService: AuthenticationService,
    private reportDataService: ReportDataService,
    private reportService: ReportService,
    private authService: AuthenticationService,
    private clientService: ClientService,
    public router: Router,
    private featureHelperService: FeatureHelperService,
    private successModalHelper: SuccessModalHelperService,
    private errorModalHelper: ErrorModalHelperService,
    private authenticationStateHelper: AuthenticationStateHelperService,
    @Optional() private featureSwitches?: FeatureSwitchService
  ) { }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  /** "See all in History" on the combined page: the History tab, showing the same selection. */
  public openHistory(state: FilterState): void {
    this.selectedTab = 1;
    this.history?.showFilters(state);
  }

  ngOnInit() {
    let featureList = new Array<string>();
    featureList.push(
      "ReportsView",
      "ReportsGenerate");

    let currentUserFeatures = this.featureHelperService.checkFeaturePermissions(featureList);
    
    if (!currentUserFeatures.filter(f => f.feature === "ReportsView")[0].enabled) {
      console.error("User does not have the required permissions to view the reports screen");
      this.router.navigate(['/login'], { queryParams: { returnUrl: window.location.pathname }});
      this.authenticationStateHelper.unauthorizedToken = true;
    }

    if (currentUserFeatures.filter(f => f.feature === "ReportsGenerate")[0].enabled) {
      this.enableGenerateReports = true;
    }

    this.featureSwitches?.isEnabled(FeatureSwitchKeys.reportsCombinedPage).pipe(takeUntil(this.unsubscribe))
      .subscribe(on => this.combinedEnabled = on === true);

    const observableArray = [];
    
    observableArray.push(this.getReports());
    observableArray.push(this.getUserDetails());
    observableArray.push(this.populateFilters());

    forkJoin(observableArray).subscribe(response => {
    });
  }

  public getReports(): Observable<any> {
    return of(
      this.reportService.GetReports().subscribe((data: ReportType[]) => {
        this.reportDataService.setReports(data);
      }, error => {
        this.errorModalHelper.show("An error has occurred, please try again", error);
        console.error(error);
      })
    );
  
  }
  public getUserDetails(): Observable<any> {
    return of(
      this.clientService.GetClientUser(this.authService.userSessionData.currentUser.applicationUserId)
        .subscribe(data => {
          this.reportDataService.clientUser = data;
      }, error => {
        this.errorModalHelper.show("An error has occurred, please try again", error);
        console.error(error);
      })
    );
  }

  public populateFilters(): Observable<any> {
    return of(
      this.clientService.GetReportClients(this.authService.userSessionData.currentUser.id).subscribe((data: ReportClient[]) => {
        this.reportDataService.setClientList(data);
      }, error => {
        this.errorModalHelper.show("An error has occurred, please try again", error);
        console.error(error);
      })
    );
  }

}
